import { AuthenticationProfileResponse } from '../interfaces/authentication-profile.response';

export class AuthenticationProfile {
  public firstName: string;
  public lastName: string;

  constructor(response?: AuthenticationProfileResponse) {
    if (response) {
      this.firstName = response.firstName;
      this.lastName = response.lastName;
    }
  }
}
